"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkWMYJ7ELBjs = require('./chunk-WMYJ7ELB.js');var _chunkU6NJVEOJjs = require('./chunk-U6NJVEOJ.js');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react = require('@emotion/react');var _jsxruntime = require('react/jsx-runtime');var i=t=>_react.keyframes`
  50% {
    box-shadow: 0 0 0 ${t} rgba(235, 87, 87, 0.125);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(235, 87, 87, 0);
  }
`,s=_styled2.default.call(void 0, _chunkWMYJ7ELBjs.a)`
  border-radius: 50%;
  padding: ${t=>t.theme.measurements.spacing(7)};
  box-shadow: 0 0 0 0 rgba(235, 87, 87, 0.5);
  animation: ${t=>i(t.theme.measurements.spacing(4))}
    2s infinite;
  transition: 0.5s;

  &:hover,
  &:focus,
  &:active {
    transform: scale(1.1);
  }

  svg {
    color: ${t=>t.theme.palette.WHITE};
  }
`;function m(){return _jsxruntime.jsx.call(void 0, s,{variant:"danger",size:"large",children:_jsxruntime.jsx.call(void 0, _chunkU6NJVEOJjs.b,{height:12,width:12})})}var u=m;exports.a = u;
